import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { TrafficAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/traffic/traffic-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const TrafficAccessRulesConst: Record<TrafficAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль TRAFFIC (Трафик) ---
  // --- Раздел TRAFFIC.SECTIONS.TRAFFIC (Трафик) ---

  // Вкладка "Оборудование"
  [TrafficAccessRulesKeyEnum.TRAFFIC_TRAFFIC_ADAPTER_READ]: {
    'TRAFFIC.enabled': true,
    'TRAFFIC.sections.TRAFFIC.tabs.ADAPTER.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [TrafficAccessRulesKeyEnum.TRAFFIC_TRAFFIC_ADAPTER_WRITE]: {
    'TRAFFIC.enabled': true,
    'TRAFFIC.sections.TRAFFIC.tabs.ADAPTER.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Вкладка "Трафик"
  [TrafficAccessRulesKeyEnum.TRAFFIC_TRAFFIC_REPORT_READ]: {
    'TRAFFIC.enabled': true,
    'TRAFFIC.sections.TRAFFIC.tabs.TRAFFIC_REPORT.accessLevel': { $gte: AccessLevelEnum.READ }
  }
};
